import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { IClassForTable } from "../../models/Class";
import { ClassService } from "../../services/class.service";

export const useGetAllClassesByGymListingIdQuery = (
  gymListingId: string | undefined,
  searchValue: string | null
) => {
  return useQuery<IClassForTable[], Error>({
    queryKey: [QUERY_CONSTANTS.GET_ALL_CLASSES_BY_GYM, gymListingId, searchValue],
    queryFn: () =>
      ClassService.getAllClassesByGymListingId(gymListingId!, searchValue).then((res) => res.data),
    enabled: !!gymListingId,
  });
};
